export default function Footer() {
  return (
    <footer className="bg-gray-50" aria-labelledby="footer-heading">
      <h2 id="footer-heading" className="sr-only">
        Footer
      </h2>
      <div className="max-w-7xl mx-auto pt-16 pb-8 px-4 sm:px-6 lg:pt-24 lg:px-8">
        <p className="mt-8 text-sm text-gray-400 md:mt-0 md:order-1">
          Developed by Achuth Rajula, Varshik Sonti, Kousthubha Das, Laxman Rao
          2022&trade;
        </p>
      </div>
    </footer>
  );
}
